import { useState, useEffect, useCallback } from 'react';
import { getUserManagementStats } from '@/api/statsService';
import { parseApiError } from '@/utils/errorHandler';
import type { parsedApiError } from '@/types/api/errors.api';
import type { userManagementStats } from './types.props';

export const useStats = () => {
    const [stats, setStats] = useState<userManagementStats | null>(null);
    const [error, setError] = useState<parsedApiError | null>(null);

    const refresh = useCallback(async () => {
        try {
            setError(null);
            const data = await getUserManagementStats();
            setStats(data);
        } catch (e: unknown) {
            setError(parseApiError(e));
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return { stats, error, refresh };
};
